import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { TfiSearch } from "react-icons/tfi";
import { IoMdClose } from "react-icons/io";
import { InfoContaienr } from "../../styled/salesCheck";
import { orderStatus } from "../../function/store";
import SalesCheckCalendar from "./salesCheckCalendar";

const Info = ({ active, tabs, searched, setSearched, getOrders, current, setCurrent }) => {
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const [openCalendar, setOpenCalendar] = useState(false);

  const isOrderHistory = active === "orderHistory";

  const handleChange = (name, value) => {
    setSearched((prev) => ({ ...prev, [name]: value }));
    if (openCalendar) setOpenCalendar(false);
  };

  const handleSearch = async () => {
    const defaultPage = { page: 1, pageSize: 8 };
    current.page !== 1 ? setCurrent(defaultPage) : await getOrders(defaultPage);
  };

  return (
    <InfoContaienr>
      <div className="heading">{tabs[active]}</div>

      {isOrderHistory && (
        <div className="date">
          <button onClick={() => setOpenCalendar(true)} className="select">
            {searched.createdAt || "날짜선택"}
          </button>
          {searched.createdAt && (
            <button onClick={() => handleChange("createdAt", null)} className="delete">
              <IoMdClose />
            </button>
          )}
        </div>
      )}

      <div className="search">
        {isOrderHistory ? (
          <>
            <span className="label">상태별</span>
            <select
              value={searched.status}
              onChange={(e) => handleChange("status", e.target.value)}>
              <option value="all">전체보기</option>
              {Object.entries(orderStatus).map(([key, label]) => (
                <option key={key} value={key}>
                  {label}
                </option>
              ))}
            </select>
            <button onClick={handleSearch} className="submit">
              <TfiSearch />
            </button>
          </>
        ) : (
          <>
            {/* <input type="text" />
            <button onClick={() => console.log(1)} className="submit">
              <TfiSearch />
            </button> */}
          </>
        )}
      </div>
      {openCalendar && (
        <SalesCheckCalendar
          setOpenCalendar={setOpenCalendar}
          date={searched.createdAt}
          changeSearched={({ name, value }) => handleChange(name, value)}
        />
      )}
    </InfoContaienr>
  );
};

export default Info;
